const isBaseDropdownOption = (option) => {
    const optionKeys = Object.keys(option || {});
    return optionKeys.includes('value') && optionKeys.includes('label') && !optionKeys.includes('options');
};
const isBaseDropdownOptionGroup = (option) => {
    const optionKeys = Object.keys(option || {});
    return optionKeys.includes('options');
};
const isMultiSelect = (value) => {
    return Array.isArray(value);
};
const isSingleSelect = (value) => {
    return !Array.isArray(value);
};
const allValuesValidRecursive = (options, value) => {
    const isValidValue = options.some(opt => {
        if (isBaseDropdownOption(opt) && isBaseDropdownOption(value)) {
            return opt.value === value.value;
        }
        else if (isBaseDropdownOptionGroup(opt)) {
            return allValuesValidRecursive(opt.options, value);
        }
    });
    return isValidValue;
};
const hasInvalidValueSingleSelect = (options, value) => {
    return !allValuesValidRecursive(options, value);
};
const hasInvalidValueMultiSelect = (options, values) => {
    return values.some(value => !allValuesValidRecursive(options, value));
};
const hasInvalidValue = (options, value) => {
    const noSingleValueSelected = value === null;
    const noMultiValuesSelected = Array.isArray(value) && value.length === 0;
    if (noSingleValueSelected || noMultiValuesSelected)
        return false;
    let hasInvalidValueInOptions = false;
    if (isMultiSelect(value)) {
        hasInvalidValueInOptions = hasInvalidValueMultiSelect(options, value);
    }
    else if (isSingleSelect(value)) {
        hasInvalidValueInOptions = hasInvalidValueSingleSelect(options, value);
    }
    return hasInvalidValueInOptions;
};
const findMissingOption = (options, value) => {
    if (hasInvalidValue(options, value)) {
        return Object.assign({}, value);
    }
};
const findMissingOptionsSingleSelect = (options, value) => {
    const missingOption = findMissingOption(options, value);
    return missingOption ? [missingOption] : [];
};
const findMissingOptionsMultiSelect = (options, values) => {
    let missingOptions = [];
    for (const val of values) {
        const missingOption = findMissingOption(options, val);
        missingOptions = missingOption ? [...missingOptions, missingOption] : missingOptions;
    }
    return missingOptions;
};
const findMissingOptions = (options, value) => {
    if (!value)
        return undefined;
    if (isMultiSelect(value)) {
        return findMissingOptionsMultiSelect(options, value);
    }
    else if (isSingleSelect(value)) {
        return findMissingOptionsSingleSelect(options, value);
    }
};

export { findMissingOptions, hasInvalidValue };
//# sourceMappingURL=utils.js.map
